import useSWR, { SWRConfiguration } from 'swr';

import { Feedback } from '../../types/feedback';
import { GetAllAsync } from '../../services/api';
import { KendoGridResult } from '../../types/KendoGridResult';

const FeedbackEndpoint = 'feedback';
const PublishedFeedbackEndpoint = 'event/feedback';

export const useGetFeedbacks = (
  params?: string,
  libraryType?: 'admin' | 'library',
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<KendoGridResult<Feedback>>(
    `${!libraryType ? '' : libraryType + '/'}${FeedbackEndpoint}?${params}`,
    GetAllAsync,
    options
  );

  if (error) console.log(error);

  return {
    data,
    isLoading,
    isError: error,
    mutate
  };
};

export const useGetPublishedFeedbacks = (
  params?: string,
  options?: SWRConfiguration
) => {
  const { data, error, isLoading } = useSWR<KendoGridResult<Feedback>>(
    `${PublishedFeedbackEndpoint}?${params}`,
    GetAllAsync,
    options
  );

  if (error) console.log(error);

  return {
    feedbacks: data?.data,
    isLoading,
    isError: error
  };
};
